import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { Button } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import { Quote } from '../../quote';

export default class RequestNewLeadTimeModal extends React.Component {
  state = {
    show: false,
    saving: false,
    notes: '',
  };

  static propTypes = {
    quoteId: PropTypes.string.isRequired,
    onChanged: PropTypes.func.isRequired,
  };

  show() {
    this.setState({ show: true, notes: '' });
  }

  hide = () => this.setState({ show: false });

  save = () => {
    this.setState({ saving: true });
    Quote.addRequestNewLeadTime(this.props.quoteId, this.state.notes)
      .then(() => {
        this.props.onChanged();
        this.hide();
      })
      .catch(() => {})
      .finally(() => this.setState({ saving: false }));
  };

  render() {
    if (!this.state.show) return null;
    return (
      <SimpleModal show={this.state.show} size="lg">
        <ModalHeader title="Request New Lead Time" />
        <ModalBody>
          <form className="container">
            <div className="row">
              <div className="col-12">
                <div className="mb-1">
                  <em>
                    Use this to request an improved lead time on this quote. The
                    Inside Sales team will work with Scheduling to review your
                    request and if a new lead time is approved, you will be
                    responsible for updating it on the quote.
                  </em>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <FormInput
                  label="Notes"
                  placeholder="Provide some details for why you are making this request"
                  type="textarea"
                  rows={4}
                  value={this.state.notes}
                  onChange={(e) => this.setState({ notes: e.target.value })}
                  required
                />             
                Request New Lead Time
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <Button
            label="Save"
            className="btn btn-primary"
            onClick={this.save}
            showSpinner={this.state.saving}
            disabled={this.state.saving}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
